import i18n from "@/i18n/config";

let pending: Promise<void> | null = null;

/**
 * Lazily fetches and registers the ownership-claim / phone-verification
 * feature's translation keys into the default i18next namespace. Kept out
 * of the eager i18n/config.ts bundle so this copy, across 6 languages,
 * does not ship in the main entry chunk for visitors who never touch
 * ownership verification, claims, or phone verification. Idempotent and
 * cached.
 */
export function ensureOwnershipClaimsLocaleLoaded(): Promise<void> {
  if (!pending) {
    pending = Promise.all([
      import("./locales/ownership-claims/en.json"),
      import("./locales/ownership-claims/es.json"),
      import("./locales/ownership-claims/fr.json"),
      import("./locales/ownership-claims/hi.json"),
      import("./locales/ownership-claims/pa.json"),
      import("./locales/ownership-claims/ur.json"),
    ]).then(([en, es, fr, hi, pa, ur]) => {
      i18n.addResourceBundle("en", "translation", en.default, true, true);
      i18n.addResourceBundle("es", "translation", es.default, true, true);
      i18n.addResourceBundle("fr", "translation", fr.default, true, true);
      i18n.addResourceBundle("hi", "translation", hi.default, true, true);
      i18n.addResourceBundle("pa", "translation", pa.default, true, true);
      i18n.addResourceBundle("ur", "translation", ur.default, true, true);
    });
  }
  return pending;
}
